import React from "react";

// .t-highlight — the sun-yellow marker behind key words in display headlines.
// A background gradient rather than a border, so it reflows with the text.
export default function Highlight({ children }) {
  return (
    <span className="bg-[linear-gradient(transparent_55%,#FFC13B_55%,#FFC13B_92%,transparent_92%)] px-[0.12em]">
      {children}
    </span>
  );
}
